<template>
    <div id="payment-outer-container">
        <div id="user-payment-container">
            <h1>Discord Server Sub - $149.99/mo</h1>
            <p>Small Delay on all commands <br>
            Ad Free on most commands<br>
            Unlimited Premium Commands for all users in your server</p>
            <img src="/assets/undraw_credit.svg" id="illustration"/>
            <v-braintree
                    authorization="production_jyjvb7tm_t8fv6dhy2mjs696j"
                    @success="onSuccess"
                    @error="onError"
                    :paypal="{flow: 'vault'}"
                    :venmo="{allowNewBrowserTab: false}"
            >
                <template v-slot:button="slotProps">
                    <v-btn v-on:click="loading = true" :loading="loading" :disabled="loading" id="custom-pay-button" @click="slotProps.submit" color="success">Pay</v-btn>
                </template>
            </v-braintree>
        </div>
    </div>
</template>

<script>
import {BASE_URL} from "../../utils/constants";
// New sub is resub too
const ENDPOINT = "api/v1/newsubServer"

// TODO: Hide nav bar here
// TODO: Hide payment button until user selects payment method
// TODO: On mobile, when user opts to use Credit Card, the container gets too tall
export default {
    name: "UserPaymentReSub",
    data(){
        return {
            loading: false
        };
    },
    mounted() {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            this.loading = false;
        })
    },
    created() {
        //let discordCode = this.$route.query.code
        //this.parseQueryString(discordCode)
        //this.exchangeCodes(discordCode)
    },
    methods: {
        //parseQueryString: function (discordCode){
        //    if (discordCode.length < 1) {
        //        console.log(discordCode)
        //        //this.$router.push({name: "Login"})
        //    }
        //},
        onSuccess (payload) {

            let body = {
                paymentMethodNonce: payload.nonce,
                planID: this.$route.params.planID,
                userID : this.$route.params.userID,
                userEmail : this.$route.params.userEmail
            }

            console.log(body)

            fetch(BASE_URL + ENDPOINT, {method: 'POST', body: JSON.stringify(body), headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }, })
                .then(response => {
                    if (response.status === 400 || response.status === 500){
                        this.$alert(
                            "Error! Please Email - optionsfambot@gmail.com with your username/email you used to sign up and a description of what you tried to do. The error most likely occurred because you have already paid or you username doesn't exist.",
                            "Error",
                            "error").then(() => this.$router.push({
                            name: "Login",
                        }));
                        this.loading = false;
                    }else{
                        console.log(response)
                        this.$alert(
                            "Success! Thanks for supporting OFB, Please check your Email for further Instructions.",
                            "Success",
                            "success"
                        ).then(() => this.$router.push({
                            name: "Settings",
                            params: {userID: this.$route.params.userID}
                        }));
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$alert(
                        "Error! Please Email - optionsfambot@gmail.com with your username and a description of what you tried to do.",
                        "Error",
                        "error"
                    )
                    this.loading = false;
                })
        },
        onError (error) {
            let message = error.message;
            console.log(message);
            this.loading = false;
        }
    }
}
</script>

<style>

    #payment-outer-container {
        height: 100%;
        width: 100%;
    }

    #illustration {
        width: 80%;
        height: auto;
        margin: 2rem auto;
    }

    #user-payment-container {
        width: 100%;
        height: 100%;
        padding: 16px 16px 10px 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    #custom-pay-button {
        width: 100%;
        margin-top: 1rem;
    }

    .braintree-heading {
        color: #FFFFFF;
    }

    @media screen and (min-width: 750px) {

        #payment-outer-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        #user-payment-container {
            width: 50%;
            max-width: 564px;
            margin: auto;
            height: fit-content;
            background-color: #404040;
            padding: 32px;
            border-radius: 10px;
            box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        }
    }

</style>